<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h2"><a id="pl-8-7"></a>CROSSWALK</p>
<p class="fig"><img src="images/8_1.jpg"/></p>
<div class="bck">
<p class="side1"><b>Finished Block:</b> 13˝ × 13˝</p>
<p class="side2"><b>2½ strips:</b> 5 print</p>
<p class="side2"><b>Background fabric:</b> 8 squares 5˝ × 5˝</p>
<p class="side2">(Makes 2 blocks.)</p>
</div>
<p class="noindentt"><i>No traffic, no waiting at stop signs. Everything is a go as you put your best foot forward and begin sewing on these lovely blocks!</i></p>
<p class="noindentt"><i>All seams are ¼˝.</i></p>
<p class="noindentt"><span class="col1"><b>1.</b></span> Make a strip set by sewing the 2½ strips together. Press the seam allowances all in the same direction. <b>1A</b></p>
<p class="fig"><img src="images/8_2.jpg"/></p>
<p class="noindentt">Trim the strips into 4˝ increments. You should get 10 from each strip set. (You’ll use 4 for each block.) <b>1B</b></p>
<p class="fig"><img src="images/8_3.jpg"/></p>
<p class="noindentt"><span class="col1"><b>2.</b></span> Cut each 5˝ background square from corner to corner once on the diagonal to make 16 triangles. <b>2A</b></p>
<p class="fig"><img src="images/8_5.jpg"/></p>
<p class="noindentt"><span class="col1"><b>3.</b></span> Fold a strip set and 2 background triangles in half, finger pressing a crease in place to mark each halfway point. Match up the crease in the triangle with the crease in the strip set and sew a background triangle to either side of the strip set. Repeat with strip sets and triangles to make 8 units. <b>3A</b></p>
<p class="fig"><img src="images/8_4.jpg"/></p>
<p class="noindentt">Trim the block so it measures 7˝ × 7˝. <b>3B</b></p>
<p class="fig"><img src="images/8_7.jpg"/></p>
<p class="noindentt">Sew the 4 units together as shown to make 1 block. <b>3C</b></p>
<p class="fig"><img src="images/8_6.jpg"/></p>
<p class="h3"><a id="pl-9-8"></a><i>Crosswalk Quilt</i></p>
<p class="fig"><img src="images/9_1.jpg"/></p>
<p class="cap">True Colors by Amy Butler for Free Spirit</p>
<p class="fig"><img src="images/9_2.jpg"/></p>
<div class="bck">
<p class="side1a"><b>Finished Quilt:</b> 67˝ X 80˝</p>
</div>
<p class="cap_h">MATERIALS</p>
<p class="noindentt">QUILT TOP: 1 roll of 2½˝ print strips</p>
<p class="noindentt">2 packages of 5˝ background squares</p>
<p class="noindentt">INSIDE BORDER: ½ yard</p>
<p class="noindentt">OUTSIDE BORDER: 1½ yards</p>
<p class="noindentt">BINDING: ½ yard</p>
<p class="noindentt">BACKING: 5 yards - vertical seam(s)</p>
<p class="cap_h">CONSTRUCTION NOTES</p>
<p class="noindentt">This quilt uses 20 blocks, cut using 8 strips sets. Inner borders are cut 2½˝ wide. Outer borders are cut 6˝ wide.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0006_chapter-title-1.vue?9a84cd96